import * as React from 'react';
import {FunctionComponent} from 'react';
import {DeviceName} from '../models/DeviceName';
import {DeviceRequirementRule} from '../models/DeviceRequirementRule';

const ReactTags = require('react-tag-autocomplete');

interface OwnProps {
    value: DeviceRequirementRule[];
    onChange: (rules: DeviceRequirementRule[]) => void;
    devices: Array<{id: DeviceName; name: string}>;
}

const quickDeviceNames: DeviceName[] = [
    DeviceName.WATER_ROWER,
    DeviceName.BIKE,
    DeviceName.SPRINTBOK,
    DeviceName.TRIA_TRAINER,
    DeviceName.ELASKO,
    DeviceName.WALL,
    DeviceName.WATER_GRINDER,
    DeviceName.SLIMBEAM,
    DeviceName.WALL_BARS,
    DeviceName.WEIGHT_BENCH,
    DeviceName.SLING,
    DeviceName.YAFI,
];

export const DeviceRequirementsInput: FunctionComponent<OwnProps> = ({value, devices, onChange}) => {
    return (
        <div className="devicerequirements">
            {value.length === 0 && (
                <div className="devicerequirements__quickselect">
                    <div className="devicerequirements__quickselecttitle">Quick select</div>
                    {quickDeviceNames
                        .map((deviceName) => {
                            const device = devices.find((d) => d.id === deviceName);
                            if (device === undefined) {
                                return null;
                            }

                            return (
                                <button
                                    key={device.id}
                                    className="btn btn-secondary devicerequirements__quickselectbutton"
                                    onClick={() =>
                                        onChange([
                                            {
                                                requires_all: true,
                                                devices: [device.id],
                                            },
                                        ])
                                    }
                                >
                                    {device.name}
                                </button>
                            );
                        })
                        .filter((d) => d !== null)}
                </div>
            )}
            {value.map((rule, index) => {
                return (
                    <div key={index} className="devicerequirements__item">
                        <span className="devicerequirements__itemlabel">
                            Rule {index + 1}
                            <button
                                className="devicerequirements__itemtrash ion-md-trash"
                                onClick={() => {
                                    onChange(value.filter((_, i) => i !== index));
                                }}
                            />
                        </span>
                        <div className="form-group">
                            <input
                                id={'requires_all_' + index}
                                type="checkbox"
                                checked={rule.requires_all}
                                onChange={(e) => {
                                    const newRules = [...value];
                                    newRules[index].requires_all = e.target.checked;
                                    onChange(newRules);
                                }}
                            />
                            <label htmlFor={'requires_all_' + index}>Requires all equipment</label>
                        </div>
                        <ReactTags
                            minQueryLength={1}
                            tags={rule.devices.map((device) => ({
                                id: device,
                                name: devices.find((d) => d.id === device)!.name,
                            }))}
                            suggestions={devices.filter(
                                (suggestion) => !rule.devices.some((device) => device === suggestion.id),
                            )}
                            onDelete={(deletedIndex: any) => {
                                rule.devices = rule.devices.filter((_, i) => i !== deletedIndex);
                                const newRules = [...value];
                                onChange(newRules);
                            }}
                            onAddition={(newTag: any) => {
                                rule.devices = [...rule.devices, newTag.id];
                                const newRules = [...value];
                                onChange(newRules);
                            }}
                        />
                    </div>
                );
            }, [])}
            <button
                className="btn btn-secondary ion-ios-add icon-left"
                onClick={(e) => {
                    e.preventDefault();
                    const newRules = [...value];
                    newRules.push({
                        requires_all: false,
                        devices: [],
                    });
                    onChange(newRules);
                }}
            >
                Add rule
            </button>
        </div>
    );
};
